
const { location: { href } } = require('window');

const url = require('url');
const _ = require('lodash');
const Q = require('q');
import config from 'config';

import ko from 'rgs-knockout';
require('./js/ko-component-debug-definitions-node');

const { modals } = require('page-common');

const optionsModalTemplate = require('./templates/modals/options-modal.html');


class DebugOptionDefinitions {
	constructor (defs) {
		defs = defs || {};

		this._defs = this._normalize(defs);
	}

	isLeaf (node) {
		return _.isString(node)
			|| (_.isObject(node) && _.isString(node.type));
	}

	_normalizeLeaf (leaf) {
		if (_.isObject(leaf)) {
			return leaf;
		}
		return {
			'boolean': {
				type: 'boolean',
				value: ko.observable(false),
			},
			'string': {
				type: 'string',
				value: ko.observable(),
			}
		}[leaf];
	}

	_normalize (defs) {
		return _.mapValues(defs, (v) => {
			if (this.isLeaf(v)) {
				return this._normalizeLeaf(v);
			}
			return this._normalize(v);
		});
	}

	extend (other) {
		_.extend(this._defs, other._defs);
	}

	get (path) {
		return ko.unwrap(_.get(_.get(this._defs, path), 'value'));
	}

	set (path, value) {
		const leaf = _.get(this._defs, path);

		if (!leaf) {
			return;
		}

		const setter = {
			'boolean': s => leaf.value(s === 'true'),
		}[leaf.type];

		if (!setter) {
			return;
		}

		setter(value);
	}
}

class DebugApi {
	constructor () {
		this._definitions = new DebugOptionDefinitions;

		this._optionsModal = modals.create({
			title: 'Choose your superpowers!',
			templateMode: 'body',
			template: {
				html: optionsModalTemplate(),
				data: this._definitions,
			},
		});

		this._ready = null;
	}

	get (path) {
		return ko.ignoreDependencies(() => {
			return this._definitions.get(path);
		});
	}

	define (defs) {
		this._definitions.extend(new DebugOptionDefinitions(defs));
		return this;
	}

	ready () {
		const { query } = url.parse(href, true);

		if (!('debug' in query)) {
			return Q();
		}

		_([].concat(query.debug))
			.filter()
			.map(str => str.split('='))
			.each(([path, value]) => {
				this._definitions.set(path, value);
			});

		if (!this._ready) {
			this._ready = Q()
				.then(() => config.cms.environment.get())
				.then(env => {
					if (env === 'prod') {
						throw new Error();
					}
				})
				.then(() => modals.ready())
				.then(() => Q.Promise((resolve) => {
					modals.show(this._optionsModal);
					this._optionsModal.on('deleted', () => resolve());
				}))
				.catch(e => {
					_.noop(e);
				});
		}

		return this._ready;
	}
}

module.exports = new DebugApi;

